import { useEffect } from 'react';

export const withNetworkStatus = (Component) => () => {
  useEffect(() => {
    const setOnline = () => {
      document.body.classList.remove('error-connection');
    };

    const setOffline = () => {
      document.body.classList.add('error-connection');
    };

    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);

    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return <Component />;
};
